"use strict";
/* eslint-disable no-undef, no-restricted-globals */
Object.defineProperty(exports, "__esModule", { value: true });
exports.File = exports.Blob = exports.FormData = void 0;
function accessValue(name) {
    // new standardized access to the global object
    if (typeof globalThis !== "undefined") {
        return globalThis[name];
    }
    // WebWorker specific access
    if (typeof self !== "undefined") {
        return self[name];
    }
    return window[name];
}
exports.FormData = accessValue("FormData");
exports.Blob = accessValue("Blob");
exports.File = accessValue("File");
